import { Component, OnInit } from "@angular/core";
import { AppConfigService, PRIVACY_POLICY_URL, TOS_URL } from "src/app/core";
import { BrandingService } from "src/app/core/services/branding.service";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
  standalone: false,
})
export class FooterComponent implements OnInit {
  currentYear: number = new Date().getFullYear();
  homeUrl: string;
  readonly TOS_URL = TOS_URL;
  readonly PRIVACY_POLICY_URL = PRIVACY_POLICY_URL;

  constructor(
    private _appConfigService: AppConfigService,
    public brandingService: BrandingService,
  ) {}

  ngOnInit() {
    this.homeUrl = this._appConfigService.homeUrl;
  }
}
